<template>
  <div>
    {{ $t('configurator:edge') }}
  </div>
</template>

<script>
import base from './base'

export default {
  extends: base,
}
</script>
